module.exports = __webpack_public_path__ + "static/teaser-2-ce97c4f091152b4a2c2c581aad9a1d5a.jpg";